<template>
  <modal>
    <div class="reward">
      <div class="card--container">
        <h1>Congratulations!</h1>
        <div v-if="reward.quote" class="reward-quote card card--white">
          <div class="quote">
            {{reward.quote}}
          </div>
          <div class="br"></div>
          <div class="credit">
            {{reward.credit}}
          </div>
        </div>


        <div v-else-if="reward.img" class="reward-img card">
          <img :src="reward.img" />
        </div>

        <button class="btn btn--outline" @click="$emit('close')">
          Finish
        </button>
      </div>
    </div>
  </modal>  
</template>

<script>
import axios from "axios";
import modal from "@/components/modal";

export default {
  components: { modal },
  data() {
    return {
      reward: {}
    };
  },
  created() {
    axios
      .get(`${process.env.VUE_APP_API_URL}clients/rewards/`)
      .then(({ data }) => {
        this.reward = data;
      });
  }
};
</script>

<style lang="less" scoped>
.reward {
  background-color: #70BFF6;
  padding: 1em;
  h1 {
    text-align: center;
  }

  button {
    width: 100%;
  }
  .reward-img {
    max-height: 60vh;
    display: flex;
    img {
      max-width: 100%;
      max-height: 60vh;

      border-radius: 20px;
      box-shadow: 5px 5px 5px grey;
      margin: 0px auto;
    }
  }
  .reward-quote {
    background-color: white;
    margin: 1em;
    padding: 1em;
    box-shadow: 5px 5px 5px grey;
    .br {
      color: lightgray;
      width: 80%;
      height: 3px;
      border-radius: 20px;
      border-style: solid;
      margin: 1em auto;
    }
    .quote {
      font-size: 25px;
      color: black;
      letter-spacing: 0;
      font-weight: 500;
      font-family: "Quicksand", sans-serif;
      text-align: center;
    }

    .credit {
      .quote;
    }


  }
};
</style>
